<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-users fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  :disabled="loading"
                  v-model.trim="user.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. Carlos"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Email :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  type="email"
                  :disabled="loading"
                  v-model.trim="user.email"
                  required
                  placeholder="E.g. email@email.com"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Roles :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  :disabled="loading"
                  v-model="user.roles"
                  :items="selectRoles"
                  item-text="label"
                  item-value="value"
                  multiple
                  placeholder="Seleccione"
                  chips
                  hint="Por favor seleccione el rol para el usuario"
                  persistent-hint
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Contraseña :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model.trim="user.password"
                  :type="showPassword ? 'text' : 'password'"
                  :disabled="loading"
                  required
                  placeholder="********"
                  :rules="id ? [] : validationRules.password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  counter
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-progress-circular
                    indeterminate
                    v-if="loading"
                  ></v-progress-circular>
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    v-else
                    :style="adminNavigationBackTheme"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { auth } from "@/firebaseConfig";
import moment from "moment";
import { getUserById, saveUser, updateUser } from "@/collections/users";

// eslint-disable-next-line no-control-regex
let emailRegEx = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export default {
  name: "user-dialog",
  props: ["users"],
  data() {
    return {
      id: "AddUser",
      showPassword: false,
      dialog: false,
      title: "",
      user: {
        name: "",
        roles: [],
        password: ""
      },
      loading: false,
      selectRoles: [
        {
          label: "Encargado",
          value: "MANAGER"
        },
        {
          label: "Propietario",
          value: "OWNER"
        },
        {
          label: "Camarero",
          value: "WAITER"
        }
      ],
      isValid: false,
      validationRules: {
        name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
        email: [
          v => !!v || "Correo electronico es requerido",
          v => emailRegEx.test(v) || "El email debe ser válido"
        ],
        password: [
          v => (!!v && !!v.trim()) || "se requiere contraseña",
          v => v.length > 6 || "La contraseña es demasiado corta"
        ]
      }
    };
  },
  computed: {
    nameAlreadyExists() {
      return this.users.some(name => {
        if (
          name.name.toLowerCase().trim() ===
            this.user.name.toLowerCase().trim() &&
          name.id.toLowerCase() !== this.id.toLowerCase()
        ) {
          return name;
        }
      });
    }
  },
  methods: {
    async open(userId) {
      this.dialog = true;
      this.id = userId;

      if (this.id === "addUser") {
        setTimeout(() => {
          this.title = "Crear un usuario";
        }, 100);
        this.dialogLoader = false;
        return;
      }

      try {
        this.user = await getUserById(this.id);
        setTimeout(() => {
          this.title = "Editar un usuario";
        }, 100);
      } catch (error) {
        let message = "Error obteniendo el usuario";
        this.setlogError("get_user", message, error.stack, this.$options.name);
        this.showErrorMessage(message);
        self.loading = false;
        this.close();
      }
    },
    submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      if (this.id !== "addUser") {
        this.updateAuthUser();
      } else {
        this.createAuthUser();
      }
    },
    async createAuthUser() {
      if (this.nameAlreadyExists) {
        this.showErrorMessage("El nombre debe ser único");
        return;
      }

      let self = this;
      self.loading = true;

      try {
        let result = await this.$api.admin.createFirebaseUser({
          email: this.user.email,
          password: this.user.password
        });

        await saveUser(result.data.uid, self.buildUser());
        self.loading = false;
        this.showSuccessMessage("Usuario guardado");
        this.close();
      } catch (error) {
        let message = "Algo salió mal";
        this.setlogError(
          "create_user",
          message,
          error.stack,
          this.$options.name
        );
        this.showErrorMessage(message);
        self.loading = false;
      }
    },
    async updateAuthUser() {
      if (this.nameAlreadyExists) {
        this.showErrorMessage("El nombre debe ser único");
        return;
      }

      let self = this;
      self.loading = true;

      let data = {
        uid: this.id,
        email: this.user.email
      };
      if (this.user.password) {
        data.password = this.user.password;
      }

      try {
        let result = await this.$api.admin.updateFirebaseUser(data);
        await updateUser(result.data.uid, self.buildUser());
        self.loading = false;
        this.showSuccessMessage("Usuario guardado");

        if (
          auth.currentUser.email === result.data.email &&
          (this.user.password || !this.user.roles.includes("OWNER"))
        ) {
          this.logout();
        } else {
          this.close();
        }
      } catch (error) {
        let message = "Algo salió mal";
        this.setlogError(
          "update_user",
          message,
          error.stack,
          this.$options.name
        );
        this.showErrorMessage(message);
        self.loading = false;
      }
    },
    buildUser() {
      let now = moment().format();
      let _user = { ...this.user, updated_on: now };
      delete _user.password;
      return _user;
    },
    logout() {
      auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearAdminData");
          this.$router.replace("/admin");
        })
        .catch(error => {
          this.showErrorMessage(error.message);
        });
    },
    close() {
      this.dialog = false;
      this.user = {
        name: "",
        roles: [],
        password: ""
      };
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style></style>
